import React from "react";
import { EmptyList } from "../EmptyList";
import LoadErrorState from "../v2/LoadErrorState";

// `asRow` renders a <tr> for use inside a <tbody>; pass false to render the
// same content as a plain block outside a table.
const ErrorStateTable = ({
  error,
  otherError,
  colSpan = 6,
  emptyTitle = "No Data",
  onRetry,
  asRow = true,
}) => {
  const failure = error || otherError;
  const content = failure ? (
    <LoadErrorState error={failure} onRetry={onRetry} />
  ) : (
    <EmptyList title={emptyTitle} />
  );

  if (!asRow) return <div className="p-4">{content}</div>;

  return (
    <tr>
      <td className="p-4" colSpan={colSpan}>
        {content}
      </td>
    </tr>
  );
};

export default ErrorStateTable;
